import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Контейнер ВНУТРИ контентной области (не поверх шапки/рельса, канон preview-platform.jsx) —
// рамку/backdrop/анимацию/крестик рисует сам продукт; нет продукта-владельца — системная заглушка
// играет тот же канон-переход 350мс сама (Оболочка отвечает за анимацию своей же заглушки).
import { useEffect, useState } from "react";
import { EmptyState, IconBtn, Ico } from "@kit-v5";
import { useT } from "../i18n/i18n";
export default function ProfileOverlay({ open, closing, hasOwner, hostRef, onRequestClose }) {
    const t = useT();
    const visible = open || closing;
    const [shown, setShown] = useState(false);
    // Вход — RAF-трюк (канон kit pp-panel): смонтировать без is-open, затем в
    // следующем кадре добавить класс, чтобы transition реально проиграл 350мс.
    useEffect(() => {
        if (!visible || closing) {
            setShown(false);
            return;
        }
        const raf = requestAnimationFrame(() => setShown(true));
        return () => cancelAnimationFrame(raf);
    }, [visible, closing]);
    return (_jsx("div", { ref: hostRef, className: "platform-profile-overlay", style: visible ? { position: "absolute", inset: 0, zIndex: 50 } : { display: "none" }, children: visible && !hasOwner && (_jsxs("div", { className: "profile-overlay-pane profile-overlay-stub" + (shown ? " is-open" : ""), role: "dialog", "aria-modal": "true", onClick: (e) => { if (e.target === e.currentTarget)
                onRequestClose(); }, children: [_jsx("div", { className: "profile-overlay-close", children: _jsx(IconBtn, { icon: Ico.x, ariaLabel: t("shell.profile.close"), tooltip: t("shell.profile.close"), onClick: onRequestClose }) }), _jsx(EmptyState, { icon: Ico.user, title: t("shell.profile.stub_title"), description: t("shell.profile.stub_description") })] })) }));
}
